import React, { useState } from "react";
import TrendAnalysis from "../components/trend_analysis/Index";
import ConjointAnalysis from "../components/conjoint/Index";
import { FaChartLine, FaCubes } from "react-icons/fa";
import PageHeader from "../components/common/PageHeader";

const TABS = [
  { key: "trend", label: "Trend Analysis", Icon: FaChartLine },
  { key: "conjoint", label: "New Product Development", Icon: FaCubes },
];

export default function TrendConjointDashboard() {
  const [selected, setSelected] = useState("trend");

  return (
    <div style={styles.wrapper}>
      <PageHeader
        title="Trend & Conjoint Analysis"
        subtitle="Explore forecast trends and conjoint insights in one place."
      />

      <div style={styles.tabRow}>
        {TABS.map((tab) => {
          const isActive = selected === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => setSelected(tab.key)}
              style={{
                ...styles.tab,
                ...(isActive ? styles.tabActive : {}),
              }}
            >
              <span
                style={{
                  ...styles.tabBadge,
                  ...(isActive ? styles.tabBadgeActive : {}),
                }}
              >
                <tab.Icon size={13} />
              </span>
              {tab.label}
            </button>
          );
        })}
      </div>

      <div style={styles.content}>
        {selected === "trend" && <TrendAnalysis embedded />}
        {selected === "conjoint" && <ConjointAnalysis embedded />}
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    width: "100%",
    minHeight: "100%",
    background: "transparent",
    padding: "0 0 24px",
    boxSizing: "border-box",
  },
  tabRow: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
    marginBottom: 14,
  },
  content: {
    width: "100%",
  },
  tab: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "7px 14px",
    borderRadius: 8,
    border: "1px solid #e6eef4",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 13,
    fontFamily: "Poppins, sans-serif",
    background: "#fff",
    color: "#0c3c54",
    transition: "background 0.15s ease, border-color 0.15s ease, color 0.15s ease",
    boxShadow: "0 2px 8px rgba(12, 60, 84, 0.04)",
  },
  tabActive: {
    background: "#032B4E",
    color: "#fff",
    borderColor: "#032B4E",
    boxShadow: "0 2px 8px rgba(3, 43, 78, 0.16)",
  },
  tabBadge: {
    width: 22,
    height: 22,
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f4f3ef",
    color: "#E06639",
    border: "1px solid #e6eef4",
  },
  tabBadgeActive: {
    background: "#E06639",
    color: "#fff",
    borderColor: "#E06639",
  },
};
